'use client';
import { getCssDimensions } from '../utils/getCssDimensions.js';

function getDimensions(element) {
    return getCssDimensions(element);
}

export { getDimensions };
//# sourceMappingURL=getDimensions.js.map
